import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Contact() {
  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '', phone: '',
    service: '', message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    // Simulate form submission
    setSubmitted(true);
    setForm({ firstName: '', lastName: '', email: '', phone: '', service: '', message: '' });
  };

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <i className="fas fa-chevron-right" />
            <span>Contact</span>
          </div>
          <h1 className="page-hero-title">
            Get In <span>Touch</span>
          </h1>
          <p className="section-desc light" style={{ marginTop: 16 }}>
            Let's discuss your signage project. Our experts are ready to help.
          </p>
        </div>
      </div>

      <section style={{ padding: '80px 0', background: 'var(--white)' }}>
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info */}
            <div>
              <span className="section-label">Reach Us</span>
              <h2 className="section-title" style={{ fontSize: '2rem', marginBottom: 36 }}>
                We're Here to Help
              </h2>

              <div className="contact-info-item">
                <div className="contact-icon"><i className="fas fa-map-marker-alt" /></div>
                <div>
                  <div className="contact-info-title">Our Office</div>
                  <div className="contact-info-val">
                    Plot No. 45, Industrial Area, Phase II,<br />
                    New Delhi – 110020, India
                  </div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon"><i className="fas fa-phone-alt" /></div>
                <div>
                  <div className="contact-info-title">Phone Numbers</div>
                  <div className="contact-info-val">
                    <a href="tel:+919810012345" style={{ color: 'var(--text-mid)' }}>+91 98100 12345</a><br />
                    <a href="tel:+911145678901" style={{ color: 'var(--text-mid)' }}>+91 11 4567 8901</a>
                  </div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon"><i className="fas fa-envelope" /></div>
                <div>
                  <div className="contact-info-title">Email Addresses</div>
                  <div className="contact-info-val">
                    <a href="mailto:info@expertadvindia.com" style={{ color: 'var(--text-mid)' }}>info@expertadvindia.com</a><br />
                    <a href="mailto:sales@expertadvindia.com" style={{ color: 'var(--text-mid)' }}>sales@expertadvindia.com</a>
                  </div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon"><i className="fas fa-clock" /></div>
                <div>
                  <div className="contact-info-title">Working Hours</div>
                  <div className="contact-info-val">
                    Monday – Saturday: 9:30 AM – 7:00 PM<br />
                    Sunday: Closed
                  </div>
                </div>
              </div>

              {/* Socials */}
              <div style={{ marginTop: 36 }}>
                <div className="section-label">Follow Us</div>
                <div className="footer-socials" style={{ marginTop: 16 }}>
                  {[
                    { icon: 'fab fa-facebook-f', href: '#', label: 'Facebook' },
                    { icon: 'fab fa-instagram', href: '#', label: 'Instagram' },
                    { icon: 'fab fa-linkedin-in', href: '#', label: 'LinkedIn' },
                    { icon: 'fab fa-youtube', href: '#', label: 'YouTube' },
                  ].map((s, i) => (
                    <a
                      key={i}
                      href={s.href}
                      aria-label={s.label}
                      style={{
                        width: 42,
                        height: 42,
                        border: '1.5px solid var(--gray-200)',
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'var(--text-light)',
                        fontSize: '0.9rem',
                        transition: 'all 0.3s',
                        textDecoration: 'none',
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.background = 'var(--secondary)';
                        e.currentTarget.style.color = 'var(--primary)';
                        e.currentTarget.style.borderColor = 'var(--secondary)';
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.background = 'transparent';
                        e.currentTarget.style.color = 'var(--text-light)';
                        e.currentTarget.style.borderColor = 'var(--gray-200)';
                      }}
                    >
                      <i className={s.icon} />
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form">
              {submitted ? (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                  <div style={{
                    width: 72,
                    height: 72,
                    background: 'rgba(212,160,23,0.1)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px',
                  }}>
                    <i className="fas fa-check" style={{ fontSize: '2rem', color: 'var(--primary)' }} />
                  </div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--secondary)', marginBottom: 12 }}>
                    Message Sent!
                  </h3>
                  <p style={{ color: 'var(--text-mid)', lineHeight: 1.7 }}>
                    Thank you for reaching out. Our team will get back to you within 24 hours.
                  </p>
                  <button
                    onClick={() => setSubmitted(false)}
                    className="btn btn-primary"
                    style={{ marginTop: 28 }}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <>
                  <div className="form-title">Request a Quote</div>
                  <form onSubmit={handleSubmit}>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          name="firstName"
                          className="form-input"
                          placeholder="Rajiv"
                          value={form.firstName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          name="lastName"
                          className="form-input"
                          placeholder="Sharma"
                          value={form.lastName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">Email Address</label>
                        <input
                          type="email"
                          name="email"
                          className="form-input"
                          placeholder="rajiv@company.com"
                          value={form.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Phone Number</label>
                        <input
                          type="tel"
                          name="phone"
                          className="form-input"
                          placeholder="+91 98100 XXXXX"
                          value={form.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Service Required</label>
                      <select
                        name="service"
                        className="form-select"
                        value={form.service}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select a service...</option>
                        <option value="led">LED Sign Boards</option>
                        <option value="acp">ACP Signage</option>
                        <option value="wayfinding">Wayfinding Systems</option>
                        <option value="hoarding">Hoardings & Billboards</option>
                        <option value="vehicle">Vehicle Branding</option>
                        <option value="digital">Digital Displays</option>
                        <option value="other">Other / Custom</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Project Details</label>
                      <textarea
                        name="message"
                        className="form-textarea"
                        placeholder="Tell us about your project, location, size requirements and any specific needs..."
                        value={form.message}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '16px' }}>
                      Send Inquiry <i className="fas fa-arrow-right" />
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Map placeholder */}
      <div style={{
        background: 'var(--secondary)',
        height: 320,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 12,
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle at 50% 50%, rgba(212,160,23,0.06) 0%, transparent 70%)' }} />
        <i className="fas fa-map-marker-alt" style={{ fontSize: '3rem', color: 'var(--primary)' }} />
        <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.8rem', color: 'var(--white)', letterSpacing: '0.04em' }}>
          Find Us in New Delhi
        </div>
        <div style={{ fontFamily: 'var(--font-condensed)', fontSize: '13px', letterSpacing: '0.15em', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase' }}>
          Plot No. 45, Industrial Area Phase II, New Delhi – 110020
        </div>
        <a
          href="https://maps.google.com"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline"
          style={{ marginTop: 8 }}
        >
          <i className="fas fa-directions" /> Get Directions
        </a>
      </div>
    </>
  );
}

export default Contact;
